import { Typography, styled } from "@mui/material";
import { themeFonts } from "../Constant/themeFont";
import TypographyLabelLarge from "./TypographyLabelLarge";

const TypographyLabelLargeMedium = styled(TypographyLabelLarge)(({ theme, color }) => ({
  fontFamily: themeFonts.medium,
}));

export default TypographyLabelLargeMedium;